<div class="shared-container">
  <ng-container *ngIf="sucesso; else formTarefa">
    <app-sucesso
      [mensagem]="'Tarefa editada com sucesso!'"
      [botaoTexto]="'Continuar'"
      (continuar)="continuar()"
    ></app-sucesso>
  </ng-container>
  <ng-template #formTarefa>
    <div *ngIf="contatoInfo" class="contato-info">
      <div class="titulo-cargo">{{ contatoInfo.cargo }}</div>
      <div class="nome-contato">{{ contatoInfo.nome }}</div>
      <div class="email-contato">{{ contatoInfo.email }}</div>
    </div>

    <div class="form-content">
      <label for="descricao">DESCRIÇÃO DA TAREFA</label>
      <textarea
        id="descricao"
        [(ngModel)]="descricao"
        class="form-control"
        placeholder="Descreva a tarefa..."
      ></textarea>

      <label for="responsavel">Responsável</label>
      <select id="responsavel" [(ngModel)]="responsibleID" class="form-control">
        <option value="" disabled>Selecione o responsável</option>
        <option *ngFor="let r of responsavel" [value]="r.id">
          {{ r.name }}
        </option>
      </select>

      <label for="tarefa">Selecionar Tarefa</label>
      <select id="tarefa" [(ngModel)]="actionID" class="form-control">
        <option value="" disabled>Selecione a tarefa</option>
        <option *ngFor="let t of tarefas" [value]="t.id">
          {{ t.description }}
        </option>
      </select>

      <div class="date-time">
        <div>
          <label for="data">Data</label>
          <input
            id="data"
            type="date"
            [(ngModel)]="data"
            min="today"
            class="form-control"
          />
        </div>
        <div>
          <label for="hora">Hora</label>
          <input
            id="hora"
            type="time"
            [(ngModel)]="hora"
            class="form-control"
            placeholder="Hora"
          />
        </div>
      </div>
    </div>
    <div class="footer-actions">
      <button
        class="btn btn-secondary"
        type="button"
        (click)="
          descricao = '';
          data = '';
          hora = '';
          responsibleID = '';
          actionID = ''
        "
      >
        LIMPAR DADOS
      </button>
      <button class="btn btn-primary" type="button" (click)="editarTarefa()">
        EDITAR TAREFA
      </button>
    </div>
  </ng-template>
</div>
